.root {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  border-bottom: 1px solid #f1f5f9;
}

.header-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.header-meta {
  font-size: 10px;
  font-weight: 600;
  color: #94a3b8;
}

.row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;
  cursor: pointer;
  font: inherit;
  text-align: left;

  &:hover {
    background: #f8fafc;
  }
}

.row-is-active {
  background: #f5f3ff;
}

.num {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 7px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.num-is-active {
  background: #7c3aed;
  color: #ffffff;
}

.row-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.row-title {
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
}

.row-date {
  font-size: 10px;
  color: #94a3b8;
}

.pill {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 7px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
}

.pill-tone-done {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #065f46;
}

.pill-tone-attention {
  background: #fff7ed;
  border: 1px solid #fdba74;
  color: #b45309;
}
